import React, { useState, useEffect, useRef } from "react";
import {
  AddToolTip,
  FieldInput,
  FieldInputNumberAsString,
  FormControlSearch,
} from "../../../components";
import { InputGroup, Image } from "react-bootstrap";
import { Field, useFormikContext } from "formik";
import { FieldInputNumber } from "../../../components";
import InvestmentHierarchy from "./InvestmentHierarchy";
import { get } from "lodash";

const getSourceCategory = (value) => {
  if (value === 2) {
    return "DeferralSources";
  } else if (value === 4) {
    return "OtherSources";
  } else if (value === 5) {
    return "DiscretionarySources";
  } else if (value === 6) {
    return "MatchSources";
  } else if (value === 7) {
    return "OtherSources";
  } else {
    return "PrevailingWages";
  }
};

const getSourceType = (value) => {
  if (value === 1) {
    return "Employee";
  } else {
    return "Employer";
  }
};

const getSourceSubCategory = (value) => {
  if (value === 1) {
    return "QMAC";
  } else if (value === 2) {
    return "QNEC";
  } else if (value === 4) {
    return "PreTax";
  } else if (value === 5) {
    return "Roth";
  } else if (value === 6) {
    return "AfterTax";
  } else if (value === 7) {
    return "PreTaxRollover";
  } else if (value === 8) {
    return "RothRollover";
  } else if (value === 9) {
    return "AfterTaxRollover";
  } else {
    return "CatchUp";
  }
};

function SourceandInvestmentHierarchy(props) {
  const {
    fields,
    withdrawalRequestId,
    style = {},
    className = "",
    //handleChange,
    filteredSourceBalances,
    selectedPlan,
    outerValues,
    allocationValues,
    values,
    setFieldValue,
    ...rest
  } = props;
  const { handleChange } = useFormikContext();
  const [searchString, setSearchString] = useState("");
  const sourceMap = !searchString
    ? filteredSourceBalances
    : filteredSourceBalances?.filter((_) => {
        return `${
          getSourceType(_.sourceType).toLowerCase() +
          getSourceCategory(_.sourceCategory).toLowerCase() +
          getSourceSubCategory(_.sourceSubCategory).toLowerCase()
        }`.includes(searchString.toLowerCase());
      });
  const [selectSourceIndex, setSelectedSourceIndex] = useState(0);
  const setBackGroundColor = () => {
    if (values[fields.hierarchyCalculationMethod]?.length === 2) {
      return "rgba(216, 216, 220, 0.3)";
    } else {
      return "#ffffff";
    }
  };
  return (
    <div className="d-flex">
      <div>
        <div
          className="sourceHierarchy"
          style={{
            marginRight: "white",
            backgroundColor: setBackGroundColor(),
          }}
        >
          <div className="d-flex flex-column sourceHierarchy_HeaderFont">
            Source Hierarchy
            <div className="search-bar-Hierarchy">
              <InputGroup>
                <InputGroup.Prepend style={{ marginTop: "20px" }}>
                  <InputGroup.Text
                    className="plan-search-button"
                    style={{
                      border: "1px solid #bdbdbd",
                      borderRight: "white",
                    }}
                  >
                    <Image src="/assets/icons/svg/search.svg" width="14px" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControlSearch
                  size="sm"
                  id="plan-search-box"
                  className="plan-search-box"
                  type="search"
                  autoComplete="off"
                  placeholder="Search Source"
                  onChange={(e) => setSearchString(e.target.value)}
                  style={{ borderLeft: "white" }}
                />
              </InputGroup>
            </div>
            <div
              className="sourceHierarchy_BodyFont"
              style={{ marginTop: "7px" }}
            >
              {
                values.sourceHierarchyDetails?.filter((_) => {
                  return (_.sourceName ?? "")
                    .toLowerCase()
                    .includes(searchString.toLowerCase());
                }).length
              }{" "}
              sources found
            </div>
            <div className="sourceHierarchy_BodyFont d-flex ">
              <div>Sources Name & Balance</div>
              <div> Hierarchy</div>
            </div>
            <div style={{ overflow: "scroll", height: "300px" }}>
              {values.sourceHierarchyDetails
                ?.filter((_) => {
                  return (_.sourceName ?? "")
                    .toLowerCase()
                    .includes(searchString.toLowerCase());
                })
                .map((val, i) => {
                  const fieldNameForSourceHierarchy = `sourceHierarchyDetails[${i}][hierarchyNumber]`;
                  return (
                    <div
                      className="sourceHierarchy_Card d-flex space-between"
                      onClick={() => {
                        setSelectedSourceIndex(i);
                      }}
                      style={{
                        marginTop: [undefined, null, ""].includes(
                          val.hierarchyNumber
                        )
                          ? "22px"
                          : "20px",
                        cursor: "pointer",
                      }}
                    >
                      <div>
                        {val.sourceName?.length > 10 ? (
                          <div>
                            <AddToolTip
                              name={val.sourceName}
                              className="sourceHierarchy_Card_Headerfont"
                              style={{ maxWidth: "170px" }}
                            >
                              {val.sourceName?.slice(0, 10)}...
                            </AddToolTip>{" "}
                          </div>
                        ) : (
                          <div className="sourceHierarchy_Card_Headerfont">
                            {val.sourceName}
                          </div>
                        )}
                        <div className="sourceHierarchy_Card_Bodyfont">
                          {/* $ {val.sourceEmployeeMap.accountBalance.toFixed(2)} */}

                          {val.sourceEmployeeMap?.accountBalance
                            ?.toFixed(2)
                            .toString()?.length > 8 ? (
                            <AddToolTip
                              name={val.sourceEmployeeMap?.accountBalance?.toFixed(
                                2
                              )}
                            >
                              ${" "}
                              {val.sourceEmployeeMap?.accountBalance
                                ?.toFixed(2)
                                .toString()
                                .slice(0, 8)}
                              ...
                            </AddToolTip>
                          ) : (
                            <>
                              ${" "}
                              {val.sourceEmployeeMap?.accountBalance?.toFixed(
                                2
                              )}
                            </>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          marginRight: "15px",
                          marginBottom: "auto",
                          marginTop: "12px",
                        }}
                      >
                        <Field
                          size="xxs"
                          isRequired
                          name={fieldNameForSourceHierarchy}
                          type="number"
                          autoComplete="off"
                          value={val.hierarchyNumber}
                          onChange={handleChange}
                          component={FieldInputNumber}
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              <p>{"Required"}</p>
                            ) : undefined;
                          }}
                          min={1}
                          max={99}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      {values[fields.hierarchyCalculationMethod]?.length === 2 && (
        <div>
          <InvestmentHierarchy
            fields={fields}
            sourceSelected={filteredSourceBalances[selectSourceIndex]}
            outerValues={outerValues}
            values={values}
            getSourceType={getSourceType}
            getSourceSubCategory={getSourceSubCategory}
            getSourceCategory={getSourceCategory}
            selectSourceIndex={selectSourceIndex}
            setFieldValue={setFieldValue}
          />
        </div>
      )}
    </div>
  );
}

export default SourceandInvestmentHierarchy;
